<div class="card">
  <div class="card-header bg-white py-3">
    <div class="m-0 text-black text-bold" i18n>Overall Average Rating for Rentals</div>
  </div>
  <div *ngIf="!isLoading">
    <div class="table-holder table-responsive" tableContentSize>
      <mat-table
        #table
        matSort
        matSortActive="latestReview.submittedAt"
        matSortDirection="desc"
        [dataSource]="dataSource"
      >
        <ng-container matColumnDef="rentalId">
          <mat-header-cell *matHeaderCellDef mat-sort-header> <ng-container i18n>Rental</ng-container></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <app-rental-name
              [rentalId]="element.rentalId"
              [image]="true"
              [imageCircle]="true"
              [clickable]="true"
              class="text-semi-bold text-link"
            ></app-rental-name>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="latestReview.submittedAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header> <ng-container i18n>Date</ng-container></mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.latestReview?.submittedAt | date : 'dd - MMM - yyyy' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="averageOverallRating">
          <mat-header-cell *matHeaderCellDef mat-sort-header> <ng-container i18n>Rating</ng-container></mat-header-cell>
          <mat-cell *matCellDef="let element" [matTooltip]="element.channelAverageOverallRating | number : '0.0-2'">
            <app-rating
              [maxRating]="maxRating(element)"
              [rating]="element.channelAverageOverallRating"
              [showLevelColor]="true"
            ></app-rating>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="source">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <ng-container i18n>Channels</ng-container></mat-header-cell
          >
          <mat-cell *matCellDef="let element">
            <img [src]="element.source | channelIcon : false" [alt]="element.source" height="25" />
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="latestReview.text">
          <mat-header-cell *matHeaderCellDef> <ng-container i18n>Review</ng-container></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="text-truncate" [matTooltip]="element.latestReview?.text">
              {{ element.latestReview?.text }}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="insights">
          <mat-header-cell *matHeaderCellDef> <ng-container i18n>AI Review Insights</ng-container></mat-header-cell>
          <mat-cell *matCellDef="let element" class="justify-content-center">
            <a href="javascript:void(0)" (click)="onInsights(element)">
              <i class="cs-icon cs-icon-file-chart-stars text-xxl"></i>
            </a>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <mat-paginator2
        #paginator
        [length]="dataSource.data.length"
        [class.hidden]="isEmpty$ | async"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
        [showFirstLastButtons]="true"
      >
      </mat-paginator2>

      <app-empty-table *ngIf="isEmpty$ | async">
        <img src="/assets/images/empty_icons/overall-rental-rating.svg" alt="" />
        <h6 i18n>No Rating Available</h6>
        <p i18n>
          You haven’t received any reviews for your rentals yet. As reviews come in from supported channels, they’ll
          appear here to help you track guest feedback and performance.
        </p>
      </app-empty-table>
    </div>
  </div>
  <app-loading-section *ngIf="isLoading"></app-loading-section>
</div>
